import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import TextField from '@mui/material/TextField';
import Loader from '../components/Loader';

const Vibes = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const logoImgRefs = useRef([]);
    const coverImgRefs = useRef([]);
    const loadedCount = useRef(0);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedListing, setSelectedListing] = useState(null);
    const [unlockCode, setUnlockCode] = useState('');
    const [drawerLoading, setDrawerLoading] = useState(false);

    const updateHeights = () => {
        logoImgRefs.current.forEach((logo, index) => {
            const cover = coverImgRefs.current[index];
            if (logo && cover) {
                const height = logo.offsetHeight;
                cover.style.height = `${height}px`;
            }
        });
    };

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getMyCalendar}`,
                    data: formData
                });

                if (response.data.items && Array.isArray(response.data.items)) {
                    setListings(response.data.items);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchListings();
    }, []);

    const handleImageLoad = (index) => {
        loadedCount.current += 1;
        if (loadedCount.current === listings.length * 2) {
            updateHeights();
        }
    };

    useEffect(() => {
        if (listings.length > 0) {
            window.addEventListener('resize', updateHeights);
            return () => {
                window.removeEventListener('resize', updateHeights);
            };
        }
    }, [listings]);

    const handleUnlock = async () => {
        if (!selectedListing) return;
        setDrawerLoading(true);
        try {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('listing_id', selectedListing.stay_listing_id);
            formData.append('id_code', unlockCode);

            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                url: `${params.baseURL}${params.endpoints.vibeStatus}`,
                data: formData
            });

            if (response.data.status == 'ok') {
                toast.success('Code Verified Successfully!');
                window.location.reload(); 
            }
        } catch (err) {
            alert("Failed to unlock vibe.");
        } finally {
            setDrawerLoading(false);
            setDrawerOpen(false);
        }
    };

    const faqs = [
        {
            question: "What is Lorem Ipsum?",
            answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            question: "Where does it come from?",
            answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
        },
    ];
    
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Vibes</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='row'>
                <div className='col-md-8'>

                    <div className='yl-header'>
                        <div className='img-title-box'>
                            <img src={'/assets/img/title/vibes_title_2.svg'} className='img-fluid img-title' alt='' />
                        </div>
                    </div>

                    {listings.length > 0 ? (
                        <div className='row'>
                            {listings.map((listing, index) => (
                                <div className='col-md-6 lb' key={listing.stay_listing_id}>
                                    <a href={listing.vibe_unlock_status === 1 ? undefined : `/manage-co-host/${listing.stay_listing_id}`} onClick={(e) => {
                                        if (listing.vibe_unlock_status === 1 || listing.vibe_unlock_status === 2) {
                                            e.preventDefault();
                                        }
                                    }}>
                                        <div className='acc-box' style={{ marginBottom: '10px' }}>
                                            <div className="apimgcibox">
                                                <div className='image-wrapper lcibox'>
                                                    <div className='ac-cover-image'>
                                                        <img
                                                            ref={(el) => (coverImgRefs.current[index] = el)}
                                                            className="ciso ap-ciso"
                                                            src={listing.cover_photo ? listing.cover_photo : '/assets/img/default_listing.jpg'}
                                                            alt={listing.listing_title || 'Untitled Listing'}
                                                            onLoad={() => handleImageLoad(index)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="logo-wrapper">
                                                    <img
                                                        ref={(el) => (logoImgRefs.current[index] = el)}
                                                        src={listing.category_info.category_image_url}
                                                        alt=''
                                                        className='cist'
                                                        onLoad={() => handleImageLoad(index)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='pltxt-box'>
                                                <div className='cat-pointer mb-0'>
                                                    <img src={listing.property_title_icon_image} alt="Profile" className="pointer-icon" />
                                                    <div className='wspl-ta-section'>
                                                        <span className='wspl-title-box'>{listing.listing_title || 'Unknown Title'}</span>
                                                        <span className='wspl-add-box'>{listing.property_address}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {listing.vibe_unlock_status === 2 && (
                                                <div 
                                                    className='co-host-box'
                                                    onClick={() => {
                                                        setSelectedListing(listing);
                                                        setDrawerOpen(true);
                                                    }}
                                                >
                                                    <span className='acc-btn-txt'>Unlock</span>
                                                </div>
                                            )}
                                            {listing.vibe_unlock_status === 1 && (
                                                <div 
                                                    className='co-host-box'
                                                    onClick={() =>
                                                        window.location.href = `/videos/${listing.stay_listing_id}`
                                                    }
                                                >
                                                    <span className='acc-btn-txt'>Manage Video(s)</span>
                                                </div>
                                            )}

                                        </div>
                                    </a>
                                
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No listings found</p>
                    )}
                </div>
                <div className='col-md-4 p-0'>
                    <div className='bfhsd'>
                        <div className='blog-box'>
                            <div class="blog">
                                <div class="blog-image">
                                    <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                                    <div class="date">May 08, 2025</div>
                                </div>
                                <div class="blog-content">
                                    <h2>What is Lorem Ipsum?</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                                    <a href="#">Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="faq-sticky">
                            {faqs.map((faq, index) => (
                            <div key={index} className='faqs-list-section'>
                                <div
                                onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                                style={{
                                    backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                                }}
                                >
                                {faq.question}
                                <i
                                    className={`fas ${
                                    activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                                    }`}
                                    style={{
                                    transition: "transform 0.3s ease",
                                    }}
                                ></i>
                                </div>
                                {activeIndex === index && (
                                <div className='faqs-ans-box'>
                                    {faq.answer}
                                </div>
                                )}
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {drawerOpen && (
                <div className="confirmation-popup-overlay">
                    <div className="confirmation-popup" style={{width:'600px'}}>
                        <div className='euc-box'>
                            <div className='popup-body' style={{position:'relative'}}>
                                <img src={'/assets/img/banners/unlock_popup_banner_1.webp'} className='img-fluid' alt='' />
                                <div className='euc-close' onClick={() => setDrawerOpen(false)}>
                                    <img src={'/assets/img/icons/popup_close.png'} className='img-fluid' alt='' />
                                </div>
                            </div>
                            <div className='popup-subcnt'>
                                <div className='ucb-row'>
                                    <div className='ucb-col-txt'>
                                        <TextField
                                            fullWidth
                                            placeholder='ENTER UNLOCK CODE'
                                            variant="outlined"
                                            value={unlockCode}
                                            onChange={(e) => setUnlockCode(e.target.value)}
                                        />
                                    </div>
                                    <div className='ucb-col-btn'>
                                        <button className="btn btn-secondary" onClick={handleUnlock} disabled={drawerLoading}>
                                            <img src={'/assets/img/icons/proceed_icon.svg'} className='img-fluid' alt='' style={{width:'44px'}} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Vibes;
